import {
    constructIds,
    nextCountReqConstructs,
    parentIdReqConstrcuts,
    clusterletConstructTags,
    sectionAsChildrenNodes,
    fieldAsChildrenNodes
} from "../config/common";
import { countOfClusterlet } from "./reactFlowService";
import { flatten } from "../store/constructs/clusterlets/selectors";
import blueprintJson from '../test/blueprint.json'
import shortUUID from "short-uuid";


const _ = require('lodash');

export const findChildren = async (node, elements, sections, fields) => {
    // console.log("findChildren", { node, elements, sections, fields })
    if (sectionAsChildrenNodes.includes(node.type) === true) {
        const children = sections?.filter(s => s.parent[0].id === node.id)
        node.children = []
        children.forEach(async c => {
            c.children = []
            c.children.push(await findChildren(c, elements, sections, fields))
            if (c?.children?.length <= 0) delete c.children
        })
        node.children = children
    }
    if (fieldAsChildrenNodes.includes(node.type) === true) {
        const children = fields?.filter(s => s.parent[0].id === node.id)
        node.children = []
        children.forEach(async c => {
            c.children = []
            c.children.push(await findChildren(c, elements, sections, fields))
            if (c?.children?.length <= 0) delete c.children
        })
        node.children = children
    }
    // console.log("node", node)
    return node;
}

export const getDeleteElement = async (elements, node) => {
    // console.log("elements", {elements, node})
    const element = elements.find(i => i.id === node.id)
    return element
}

const generateCloneData = async (item, parent, elements, sections, fields) => {


    if (!item.type) item.type = constructIds.find(i => i.type === item.tag).id
    if (!item.tag) item.tag = constructIds.find(i => i.id === item.type).type

    if (nextCountReqConstructs.includes(item.tag)) {
        const nextCount = countOfClusterlet(item.tag, elements);
        item.id = shortUUID.generate() + `-${nextCount}`;
        item.position = { x: 150, y: 200 }
    }

    else if (parentIdReqConstrcuts.includes(item.tag)) {
        //if your cloning a section/ field at the last level in tree, parent will be undefined
        //you will need to get the parent from sections/fields array in store
        if (parent === undefined) {
            let clonedConstruct = {}
            if (item.tag === "section") {
                clonedConstruct = sections.find(s => s.id === item.id)
            } else {
                clonedConstruct = fields.find(f => f.id === item.id)
            }
            item.parent = clonedConstruct.parent

        } else {
            item.parent = [{
                id: parent.id,
                type: typeof (parent.type) == "string" ? parent.type : constructIds.find(c => c.id == parent.type).type
            }]
        }
        item.id = shortUUID.generate()

    } else {
        item.id = shortUUID.generate()
    }

    const parentOfNextItem = {
        id: item.id,
        type: item.type
    }

    if (item.children?.length) {
        item.children.map((i) => generateCloneData(i, parentOfNextItem, elements, sections, fields));
    }
    return item
};



export const separateConstructsAccToTag = async (cc) => {

    const clonedConstructs = JSON.parse(JSON.stringify(cc))

    const clusterlet = await clonedConstructs.find(c => clusterletConstructTags.includes(c.tag))
    delete clusterlet?.children;
    delete clusterlet?.tag;

    const sections = await clonedConstructs.filter(c => c.tag === "section")
    sections.forEach(section => {
        delete section?.tag
        delete section?.children;
    });

    const fields = await clonedConstructs.filter(c => c.tag === "field")
    fields.forEach(field => {
        delete field?.tag
        delete field?.children
    })

    const userTrigger = await clonedConstructs.find(c => c.tag === "user_trigger")
    delete userTrigger?.children
    delete userTrigger?.tag

    const message = await clonedConstructs.find(c => c.tag === "message")
    delete message?.children
    delete message?.tag

    const rrdef = await clonedConstructs.find(c => c.tag === "rrdef")
    delete rrdef?.tag

    const instance = await clonedConstructs.find(c => c.tag === "instance")
    delete instance?.tag

    const network = await clonedConstructs.find(c => c.tag === "network")
    delete network?.tag

    return {
        clusterlet,
        sections,
        fields,
        userTrigger,
        message,
        rrdef,
        instance,
        network
    }
}


export const findClonedConstrcuts = async ({ original, clusterlets, sectionsInState, fieldsInState, nodes, parent }) => {

    const clonedNode = JSON.parse(JSON.stringify(original))
    const sections = JSON.parse(JSON.stringify(sectionsInState))
    const fields = JSON.parse(JSON.stringify(fieldsInState))



    const nodeAndChildren = await findChildren(clonedNode, nodes, sections, fields)

    // console.log("node and children", nodeAndChildren)

    //to generate new ids and the respective parent ids for the clone
    const node = JSON.parse(JSON.stringify(nodeAndChildren))
    // const parent = node.parent[0]? node.parent[0] : undefined
    const clone = await generateCloneData(nodeAndChildren, parent, clusterlets, sections, fields)
    // console.log("clone", clone)

    //to flatten the nested array of node and its children
    const constrcutsOfClone = await flatten([], clone)
    // console.log("constrcuts of clone", constrcutsOfClone)

    const constructs = await separateConstructsAccToTag(constrcutsOfClone)
    // console.log("constructs", constructs)

    return constructs
}

export const getEditClusterlet = (payload) => {

    // console.log("payload", payload)
    const { nodes, selectedNode, clusterletConnections } = payload
    const clusterlets = JSON.parse(JSON.stringify(nodes))

    const clusterletOfProfile = clusterlets.find(node => {
        if (node.profile) {
            if (node.profile[0]?.id === selectedNode.id) return node
        }
    })
    delete clusterletOfProfile.profile


    //connection string to be deleted
    const connection = clusterletConnections.find(connection => connection.source === clusterletOfProfile.id && connection.target === selectedNode.id)

    const editedClusterlet = clusterletOfProfile

    // console.log("edited element and connection", {editedClusterlet, connection})

    return {
        editedClusterlet,
        connection
    }

}


export const findEventsAndTransactionsAssociatedWithDeletedClusterlet = async (payload) => {
    // console.log("payload", payload)

    const { deleteElement, events, transactions } = payload
    const undoRedoEventData = [];

    const eventsToBeDeleted = events.filter(event => event.src === deleteElement || event.dst === deleteElement)
    // console.log(eventsToBeDeleted)

    const eventIdsToBeDeleted = eventsToBeDeleted.map(event => event.id)
    // console.log(eventIdsToBeDeleted)

    let editTransactionsIds = [];
    let editTransactions = [];

    await transactions.forEach(async tran => {

        const transactionEventsLength = tran.events.length

        await tran.events?.forEach((event, index) => {
            if (eventIdsToBeDeleted.includes(event.id)) {
                // console.log({id: event.id})

                /**for undo redo */
                const eventData = {
                    event: eventsToBeDeleted.find(item => item.id === event.id),
                    transaction: tran.id,
                    order: event.order
                }
                undoRedoEventData.push(eventData)

            }
        })

        const newEvents = tran.events.filter(event => !eventIdsToBeDeleted.includes(event.id))
        tran.events = newEvents

        /**if events are deleted ie transaction edited, return those transactions */
        // if(transactionEventsLength !== newEvents.length) editTransactionsIds.push(tran.id)
    })

    // console.log({editTransactionsIds})

    editTransactions = transactions?.map(trans => {
        const clusterlets = trans.clusterlets.map(item => item.id)
        // if(editTransactionsIds.includes(trans.id)) {
        if (clusterlets.includes(deleteElement)) {
            const filteredClusterlets = trans.clusterlets.filter(node => node.id !== deleteElement)
            // console.log("filtered clusterlets", filteredClusterlets)
            const filteredEvents = trans.events.filter(event => eventIdsToBeDeleted.includes(event.id) === false)
            trans.events = filteredEvents;
            trans.clusterlets = filteredClusterlets;
            return trans
        }
    }).filter(i => i)


    // console.log({eventIdsToBeDeleted, editTransactions,undoRedoEventData})

    return {
        deleteEvents: eventsToBeDeleted,
        editTransactions,
        undoRedoEventData
    }
}

export const cretaeInstanceForClone = (payload) => {

    const { original, newNode, instances } = payload

    const instanceOfOriginal = instances.find(instance => instance.attributes.type === original.id)
    // console.log({instanceOfOriginal})

    let instanceOfNewNode = {}

    if (instanceOfOriginal) {

        instanceOfNewNode = {
            ...instanceOfOriginal,
            id: shortUUID.generate(),
            attributes: { ...instanceOfOriginal.attributes, type: newNode.id }
        }

    }

    return instanceOfNewNode
}


export const setHandler = (selectedTransactionObj, selectedTemplate, userdefinedClusterlets, invokeId) => {

    let handlers = [];
    selectedTransactionObj.children.forEach(element => {
        if (element.type === 'sendmsg') {
            let handler = {
                id: shortUUID.generate(),
                event: element.name,
                category: 'template',
                invokeId
            };
            const { handlerType, clusterlet } = getHandlerTypeAndClusterlet(element.name, selectedTemplate);
            handler.type = handlerType;
            if (handlerType === 'onsend') {
                handler.data = `function ${handlerType}_${element.name}(instance,transaction,message)\n----- handler code goes here-----\nend\n`;
            } else {
                handler.data = `function ${handlerType}_${element.name}(instance,transaction,message,messageSource)\n----- handler code goes here-----\nend\n`;
            }
            handler.clusterlet = clusterlet;

            if (clusterlet !== undefined && userdefinedClusterlets.includes(clusterlet)) handlers.push(handler);

        }
    });
    return handlers;
}

export const getHandlerTypeAndClusterlet = (event, selectedTemplate) => {
    const connectors = selectedTemplate.metajson.connectors;
    let handlerType;
    let connector;
    for (let key of Object.keys(connectors)) {
        connector = key;
        if (connectors[key].from.includes(event)) {
            handlerType = 'onsend';
            break;
        }
        if (connectors[key].to.includes(event)) {
            handlerType = 'onrecv';
            break;
        }
    }
    const clusterlet = selectedTemplate?.connected ? selectedTemplate?.connected[connector] : undefined;
    return { handlerType, clusterlet };
}

export const findHandlers = (elementData, invokedTemplate, handlers) => {
    let handlersArray = [];
    const metaJson = invokedTemplate?.metajson;

    if (invokedTemplate.connected) {
        for (const connector in invokedTemplate.connected) {
            for (const con in metaJson.connectors) {
                if (con === connector) {
                    const sendingEvents = metaJson.connectors[con].from;
                    const recieveEvents = metaJson.connectors[con].to;

                    sendingEvents.forEach(event => {
                        const handlerData = handlers.filter(handle => handle.event == event && handle.clusterlet == invokedTemplate.connected[connector] && handle.type == 'onsend')
                        handlersArray = [...handlersArray, ...handlerData];
                    })

                    recieveEvents.forEach(event => {
                        const handlerData = handlers.filter(handle => handle.event == event && handle.clusterlet == invokedTemplate.connected[connector] && handle.type == 'onrecv')
                        handlersArray = [...handlersArray, ...handlerData];

                    })
                }
            }
        }
    }
    return handlersArray;
}


export const shallowCopy = (obj) => {
    return JSON.parse(JSON.stringify(obj));
}

export const validateTemplateConnection = () => {


}

export const checkTemplate = (templates, node) => {



    const templateNode = templates.find(template => template.id === node)

    if (templateNode != undefined) return true;

}


/** convert object key array to normal array */
export const convertToArray = (object) => {

    let array = []

    if (object == null)
        return array;

    (Object.keys(object) || []).forEach(key => {
        array.push({
            key,
            ...object[key]
        })
    })

    return array;
}


export const setBlueprintDataToLocalStorage = (docId, constructs, views, lastUpdate) => {

    const stringifiedConstructs = JSON.stringify(constructs);
    const strigifiedViews = views?.views !== undefined ? JSON.stringify(views.views) : JSON.stringify([]);
    localStorage.setItem(`constructs_${docId}`, stringifiedConstructs);
    //localStorage.setItem(`lastUpdate_${docId}`, lastUpdate);
    sessionStorage.setItem(`lastUpdate_${docId}`, lastUpdate);
    localStorage.setItem(`views_${docId}`, strigifiedViews);

}

export const setLastUpdateTimeToLocalStorage = (docId, lastUpdate) => {
    //localStorage.setItem(`lastUpdate_${docId}`, lastUpdate);
    sessionStorage.setItem(`lastUpdate_${docId}`, lastUpdate);
}

export const getConstructsFromLocalStorage = (docId) => {
    const constructs = localStorage.getItem(`constructs_${docId}`);
    return constructs;
}

export const isTwoJsonEqual = (json1, json2) => {
    return _.isEqual(json1, json2);
}

export const checkBPConstructsEqual = (docId, constructsInState) => {
    const constructdInLocalStorage = JSON.parse(getConstructsFromLocalStorage(docId));
    const isEqual = isTwoJsonEqual(constructsInState, constructdInLocalStorage);
    return isEqual;
}

export const getLastUpdateTimeFromLocalStorage = (docId) => {
    //const dateTime = localStorage.getItem(`lastUpdate_${docId}`);
    const dateTime = sessionStorage.getItem(`lastUpdate_${docId}`);
    return dateTime;
}

export const getViewsFromLocalStorage = (docId) => {
    const views = localStorage.getItem(`views_${docId}`);
    return views;
}

export const checkBPViewsEqual = (docId, viewsInState) => {
    const viewsInLocalStorage = JSON.parse(getViewsFromLocalStorage(docId));
    const isEqual = isTwoJsonEqual(viewsInState.views, viewsInLocalStorage);
    return isEqual;
}

export const validateDelegatedTemplateConnection = (connection, templates, clustelets) => {

    const allNodes = [...templates, ...clustelets];
    const filteredSrcNode = allNodes.filter(node => node.id == connection.source);
    const filteredDstNode = allNodes.filter(node => node.id == connection.target);

    console.log('filters--->', { filteredSrcNode, filteredDstNode })

    if (filteredSrcNode.length == 0 || filteredDstNode.length == 0) {
        return false;
    }

    return true;

}

export const filterBlueprints = (blueprints) => {
    if (blueprints === undefined) return [];
    const latest = blueprints.filter(bp => bp?.name !== "").sort((a, b) => b.updatedAt - a.updatedAt);
    const filtered = latest.slice(0, 10);
    const sortedBlueprints = filtered.sort((a, b) => a.name.localeCompare(b.name));
    return sortedBlueprints;
}

export const generateFieldTreeJson = (parent, parentArray, fields, mappedField) => {


    const generateTree = (parentId, array, stack) => {
        let tree = [];
        console.log({ array })
        array.forEach((item, index) => {
            if (item.parent[0]?.id === parentId) {
                if (item.name == '__stats__') return;
                let obj = { ...item };
                obj.title = item.name;

                if (item.type === 11) {
                    obj.expanded = true;
                }
                obj.tagLabel = stack ? stack + '.' + item.name : item.name;

                console.log(mappedField, '==', obj.tagLabel, 'conditionss')
                if (mappedField !== undefined && mappedField === obj.tagLabel) {
                    obj.expanded = true;
                }
                obj.children = generateTree(item._id, fields, obj.tagLabel);
                tree.push(obj);
            }
        });
        return tree;
    }

    return generateTree(parent, parentArray);

}

export const removeLastUpdatedTime = (docId) => {
    //localStorage.removeItem(`lastUpdate_${docid}`);
    sessionStorage.removeItem(`lastUpdate_${docId}`);
}

export const findResponseEventMessages = ({ transactionId, transactions, events, clusterlets, messages }) => {

    console.log('data in ---', { transactionId, transactions, events, clusterlets, messages })

    // const selectedEvent = events.find(item => item._id === event)

    // const selectedEvent = events.find(item => item.name === eventName && (item.src === clusterlet || item.dst === clusterlet))

    const selectedTransaction = transactions.find(item => item._id.toString() == transactionId)

    console.log('trscatoinsel---------', selectedTransaction)

    const selectedTransactionEvents = events.filter(e => selectedTransaction.events.map(item => item.id).includes(e._id))

    console.log('selectedTransactionEvents---------', selectedTransactionEvents)


    const delegates = clusterlets.filter(item => item.type === 1).map(item => item._id)

    console.log('delegates---------', delegates)


    const responseEvents = selectedTransactionEvents.filter(item => delegates.includes(item.dst))

    console.log('responseEvents---------', responseEvents)

    const responseMessages = responseEvents.map(item => item.message)

    console.log('responseMessages---------', responseMessages)


    const responseEventMessages = messages.filter(item => responseMessages.includes(item._id))

    console.log('responseEventMessages---------', responseEventMessages)


    // console.log({ selectedEvent, selectedTransaction, selectedTransactionEvents, responseEvents, responseMessages, responseEventMessages })

    return responseEventMessages


}



export const findEventMessages = ({ event, clusterlet, transactions, events, clusterlets, messages }) => {
    console.log({ clusterlets, transactions, events, messages, event, clusterlet });
    const selectedEvent = events.find(item => item._id === event)

    // const selectedEvent = events.find(item => item.name === eventName && (item.src === clusterlet || item.dst === clusterlet))

    const selectedTransaction = transactions.find(item => item.events.map(e => e.id).includes(selectedEvent?._id))

    const selectedTransactionEvents = events.filter(e => selectedTransaction.events.map(item => item.id).includes(e._id))

    const delegates = clusterlets.filter(item => item.type === 1).map(item => item._id)

    const responseEvents = selectedTransactionEvents.filter(item => delegates.includes(item.dst))

    const responseMessages = responseEvents.map(item => item.message)

    const responseEventMessages = messages.filter(item => responseMessages.includes(item._id))

    console.log({ selectedEvent, selectedTransaction, selectedTransactionEvents, responseEvents, responseMessages, responseEventMessages })

    return responseEventMessages


}

export const generateFieldEventTreeJson = (parents, parentArray, messages, mappedField) => {
    const generateTree = (parentId, array, stack) => {
        const messageIds = messages.map(ele => ele._id.toString());
        let tree = [];
        array.forEach((item, index) => {
            if (item.parent[0]?.id == parentId) {
                if (item.name == '__stats__') return;
                let obj = { ...item };
                obj.title = item.name;

                if (item.type === 11) {
                    obj.expanded = true;
                }
                obj.tagLabel = stack ? stack + '.' + item.name : item.name;
                // console.log("object---->", obj.tagLabel, mappedField)
                if (mappedField !== undefined && mappedField === obj.tagLabel) {
                    obj.expanded = true;
                }
                if(messageIds.includes(item.attributes.type)) {
                    obj.children = generateTree(item.attributes.type, parentArray, obj.tagLabel);
                } else {
                    obj.children = generateTree(item._id, parentArray, obj.tagLabel);
                }
               
                tree.push(obj);
            }
        });
        return tree;
    }

    let treeData = [];

    parents.forEach(item => {
        const tree = generateTree(item._id, parentArray)
        treeData = [
            ...treeData,
            {
                title: item.name,
                expanded: true,
                id: item._id,
                children: [...tree],
                disabled: true   // For message should be non selectable
            }
        ]

    })

    //    console.log(treeData)
    return treeData;
}

export const getBlueprintData = (construct) => {

    let emptyJson = [];

    if (construct == 'views') {
        return blueprintJson?.views?.views
    }
    else {
        if (blueprintJson?.constructs[construct] !== undefined) {
            return blueprintJson?.constructs[construct]
        }
        else return emptyJson;

    }

}

export const getFirstOrderEvents = (events, clusterlets) => {
    let firstOrderEvents = []
    events.map(event => {
        clusterlets.map(clusterlet => {
            if (event.src == clusterlet._id && clusterlet.type == 1) {
                firstOrderEvents.push(event)
            }
        })
    })
    return firstOrderEvents;
}

export const getDetailsFromUrl = () => {
    const segments = window.location.pathname.split('/')
    return {
        slug: segments[2],
        blueprintId: segments[3],
        screen: segments[4],
        entityId: segments[5]
    }
}


